import React from 'react';
import Form from '../common/Form';
import { Field, Formik } from 'formik';
import TextArea from '../common/TextArea';
import { uppercaseFirstLetter } from '../../util/string';
import styled from 'styled-components';
import { IonButton, IonCol } from '@ionic/react';
import LabeledInput from '../../mdc/LabeledInput';
import * as Yup from 'yup';
import { User } from 'firebase/auth';

interface ContactFormValues {
  name: string;
  email: string;
  message: string;
}

interface ContactFormProps {
  currentUser?: User | null;
  onSubmit: (values: ContactFormValues) => Promise<void>;
}

const SubmitButtonContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 16px;
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const SubmitButton = styled(IonButton)`
  margin-bottom: 32px;
`;
const StyledForm = styled(Form)`
  width: 100%;
  max-width: 400px;
`;

const ContactForm: React.FC<ContactFormProps> = ({ currentUser, onSubmit }) => {
  return (
    <Formik
      initialValues={{
        name: currentUser?.displayName || '',
        email: currentUser?.email || '',
        message: '',
      }}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        setSubmitting(true);

        try {
          await onSubmit(values);

          resetForm({
            values: {
              name: currentUser?.displayName || '',
              email: currentUser?.email || '',
              message: '',
            },
          });
        } catch (e) {
          console.error(e);
        } finally {
          setSubmitting(false);
        }
      }}
      validateOnMount
      validationSchema={Yup.object({
        email: Yup.string().email().required(),
        message: Yup.string().required('Message is required'),
        name: Yup.string().required('Name is required'),
      })}
    >
      {({
        handleSubmit,
        touched,
        errors,
        dirty,
        isValid,
        isSubmitting,
        values,
        setFieldValue,
        setFieldTouched,
      }) => (
        <StyledForm onSubmit={handleSubmit}>
          <Field
            as={LabeledInput}
            label="Name"
            name="name"
            error={touched.name && uppercaseFirstLetter(errors.name as string)}
          />
          <Field
            as={LabeledInput}
            label="Email"
            name="email"
            error={
              touched.email && uppercaseFirstLetter(errors.email as string)
            }
          />
          <Field
            as={TextArea}
            label="Message"
            name="message"
            rows={4}
            resizable={false}
            maxLength={3000}
            error={
              touched.message && uppercaseFirstLetter(errors.message as string)
            }
          />
          <SubmitButtonContainer>
            <IonCol>
              <SubmitButton
                type="submit"
                disabled={!dirty || !isValid || isSubmitting}
                expand="block"
              >
                Send
              </SubmitButton>
            </IonCol>
          </SubmitButtonContainer>
        </StyledForm>
      )}
    </Formik>
  );
};

export default ContactForm;
